import { Component, Inject, Input, OnInit, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { MSAL_GUARD_CONFIG, MsalBroadcastService, MsalGuardConfiguration, MsalService } from '@azure/msal-angular';
import { AccountInfo, InteractionStatus, RedirectRequest } from '@azure/msal-browser';
import { KENDO_BUTTON } from '@progress/kendo-angular-buttons';
import { userOutlineIcon } from '@progress/kendo-svg-icons';
import { filter, Subject, takeUntil } from 'rxjs';
import { emptyHeaderToggleI, HeaderToggleI } from '../../_models/header_objects';

@Component({
    selector: 'app-login',
    imports: [KENDO_BUTTON],
    templateUrl: './login.component.html',
    styleUrl: './login.component.css'
})
export class LoginComponent implements OnInit {

  // @Input() parentUserData: HeaderToggleI = emptyHeaderToggleI();
  loginDisplay = false;
  private readonly _destroying$ = new Subject<void>();
  public icons = { login: userOutlineIcon };
  // userTypeData: HeaderToggleI = emptyHeaderToggleI();
  constructor(private router: Router
    , @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
    private authService: MsalService,
    private msalBroadcastService: MsalBroadcastService,
  ) { }

  ngOnDestroy(): void {
    this._destroying$.next(undefined);
    this._destroying$.complete();
  }

  // ngOnChanges(changes: SimpleChanges): void {
  //     if (changes['parentUserData'], changes['parentUserData'].currentValue) {
  //       this.userTypeData = this.parentUserData;
  //     }
  // }

  ngOnInit(): void {
    this.msalBroadcastService.inProgress$
      .pipe(
        filter((status: InteractionStatus) => status === InteractionStatus.None),
        takeUntil(this._destroying$)
      )
      .subscribe(() => {
        this.setLoginDisplay();
        this.checkAndSetActiveAccount();
      })
  }
  setLoginDisplay() {
    this.loginDisplay = this.authService.instance.getAllAccounts().length > 0;
    if (this.loginDisplay) {
      this.router.navigate(['home']);
    }
  }

  loginRedirect() {
    if (this.msalGuardConfig.authRequest) {
      this.authService.loginRedirect({ ...this.msalGuardConfig.authRequest } as RedirectRequest);
    } else {
      this.authService.loginRedirect();
    }
  }
  activeAccount: AccountInfo | null = null;
  checkAndSetActiveAccount() {
    /**
     * If no active account set but there are accounts signed in, sets first account to active account
     * To use active account set here, subscribe to inProgress$ first in your component
     * Note: Basic usage demonstrated. Your app may require more complicated account selection logic
     */
    this.activeAccount = this.authService.instance.getActiveAccount();
    if (!this.activeAccount && this.authService.instance.getAllAccounts().length > 0) {
      let accounts = this.authService.instance.getAllAccounts();
      this.authService.instance.setActiveAccount(accounts[0]);
    }
  }
}
